import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlossaryService {
  public static Glossary: any = {
    aboutGalleryText: 'Галерија српске историје представља колекцију од преко 1000 змаменитости и преко 2500 личности из богате српске историје, разврстаних у 15 категорија. Свака личност представљена је на основу јавно доступних података. Почевши од Беле Србије, преко доба Немањића и борбе за ослобођење, па све до модерне републике, инспиративни људи су градили ову земљу и остављали свој неизбрисиви печат. Једни су постали славни по вођењу и одбрани државе, други су ширили религијска и филозофска уверења, трећи су доприносили развоју културе и уметности, а последњи су афирмисали земљу кроз најразличитија спортска надметања. Без икакве сумње, наша држава је имала и хероје и грешнике, али ова Галерија не суди ко припада којој страни, јер свако мишљење води субјективним поделама које би умањиле квалитет исте.',
    aboutGalleryTitle: 'О галерији',
    aboutUsText: 'Иза овог издања Галерије не стоје стручна лица из области изучавања српске историје, већ обични ентузијасти. Стога, описи историјских догађаја и личности јесу преузимани из јавно доступних извора, те постоји могућност да нису историјски прецизни. Сваки добронамерни коментар и конструктивна критика биће са радошћу прихваћени. Иза креирања Галерије стоји добра намера и велика љубав према српској историји, са циљем да уједињује и едукује, а не поларизује мишљење.',
    aboutUsTitle: 'О нама',
    actions: 'Акције',
    achievementsText: 'Истакнута дела - текст',
    achievementsTitle: 'Истакнута дела - наслов',
    add: 'Додај',
    addArtWork: 'Додај уметничко дело',
    addBattle: 'Додај битку',
    addCategory: 'Додај категорију',
    addCharacter: 'Додај личност',
    addChronology: 'Додај хронику',
    addChurch: 'Додај светињу',
    addEpoch: 'Додај епоху',
    addQuote: 'Додај цитат',
    addSportAchievement: 'Додај спортски успех',
    addTag: 'Додај таг',
    admin: 'Админ',
    agePluralFew: 'година',
    agePluralMany: 'године',
    art: 'Уметност',
    artWorkAuthor: 'Аутор',
    artWorkAuthorSlug: 'Слуг креатора',
    artWorkName: 'Назив дела',
    artWorks: 'Уметничка дела',
    artWorkSlug: 'Слуг дела',
    artWorkType: 'Тип дела',
    battleEnemyEstimate: 'Противник - процена',
    battleEnemyName: 'Противник - назив',
    battleLeader: 'Лидер',
    battleLeaderSerbian: 'Наш лидер',
    battleLeaderSlug: 'Слуг лидера',
    battleName: 'Назив битке',
    battleOutcome: 'Исход',
    battles: 'Славне битке',
    battlesGlory: 'Славне битке',
    battleSlug: 'Слуг битке',
    biography: 'Биографија',
    birthCity: 'Место рођења',
    birthDay: 'Дан рођења',
    birthdayCalendar: 'Календар',
    birthDeath: 'Рођење - смрт',
    birthMonth: 'Месец рођења',
    birthOnly: 'Рођење',
    birthYear: 'Година рођења',
    bornToday: 'Рођени на данашњи дан',
    bravo: 'Браво!',
    cancel: 'Одустани',
    categories: 'Категорије',
    category: 'Категорија',
    categoryName: 'Назив категорије',
    characters: 'Личности',
    check: 'Провери',
    chronology: 'Хроника',
    chronologySerbianHistory: 'Времеплов',
    chronologyText: 'Текст хронике',
    chronologyType: 'Тип хронике',
    churches: 'Духовне светиње',
    churchesSpiritual: 'Духовне светиње',
    churchFounder: 'Оснивач',
    churchFounderSlug: 'Слуг оснивача',
    churchName: 'Назив светиње',
    churchSlug: 'Слуг светиње',
    city: 'Град',
    contact: 'Контакт',
    contactCooperation: 'Потенцијална сарадња',
    contactError: 'Пријава грешке',
    contactForm: 'Контакт форма',
    contactSendError: 'Грешка. Нису попуњена сва поља.',
    contactSendMessage: 'Захваљујемо Вам на слању поруке.',
    contactSuggestion: 'Предлог за побољшање',
    other: 'Остало',
    coppiedSuccessfully: 'Успешно копиран линк.',
    dark: 'Тамна',
    Date: 'Датум',
    dateFromTo: 'Датум од - до',
    death: 'Смрт',
    email: 'Имејл',
    epoch: 'Епоха',
    epochList: 'Листа епоха',
    epochName: 'Назив епохе',
    epochs: 'Епохе',
    firstName: 'Име',
    frontPage: 'Насловна страна',
    fullName: 'Пуно име',
    fullTitle: 'Занимање',
    galleryTitle: 'Галерија српске историје',
    generalData: 'Основни подаци',
    heritageTitle: 'Знаменитости',
    homepage: 'Почетна',
    instagram: 'Инстаграм',
    keyNotes: 'Времеплов',
    knowledgeQuiz: 'Квиз знања',
    lastName: 'Презиме',
    light: 'Светла',
    Location: 'Локација',
    login: 'Пријави се',
    logout: 'Одјави се',
    matchImages: 'Споји слике са личностима',
    messageText: 'Текст поруке ',
    messageType: 'Врста поруке ',
    nickName: 'Надимак',
    oldness: 'Године живота',
    open: 'Отвори',
    order: 'Редослед',
    orderPrint: 'Наручи штампано издање',
    poreklo: 'Порекло',
    quoteAuthorName: 'Назив аутора',
    quoteAuthorSlug: 'Слуг аутора',
    quotes: 'Цитати',
    quoteSlug: 'Слуг цитата',
    quotesTitle: 'Српски цитати',
    quoteText: 'Текст цитата',
    send: 'Пошаљи',
    serbianSideEstimate: 'Наша страна - процена',
    serbianSideName: 'Наша страна - назив',
    shortDescription: 'Кратак опис',
    similarResults: 'Из исте категорије...',
    slug: 'Слуг',
    sport: 'Спорт',
    sportAchievementName: 'Назив достигнућа',
    sportAchievementRepeats: 'Сва освајања',
    sportAchievements: 'Спортски успеси',
    sportAchievementType: 'Тип успеха',
    sportAchievementWinner: 'Освајач',
    sportAchievemnSlug: 'Слуг достигнућа',
    sportAchievemntName: 'Назив достигнућа',
    sportWinnerSlug: 'Слуг освајача',
    tag: 'Таг',
    tags: 'Тагови',
    text: 'Текст',
    titleName: 'Насловно име',
    topTen: 'Важна личност',
    tryAgain: 'Пробај поново!',
    unknown: 'непознато',
    wiki: 'Википедија',
    year: 'Година',
    Year: 'Година',
    yearMonth: 'година.месец',
    youtube: 'Јутјуб',
  };
}
